module.exports = __webpack_public_path__ + "img/devices-name.2e73b6a2.png";